// extracted by mini-css-extract-plugin
module.exports = {"countdownTimer":"CountdownTimer_countdownTimer__2mVTv","timeContainer":"CountdownTimer_timeContainer__FBuby","timeLeft":"CountdownTimer_timeLeft__dbW2Q"};